import React, { Component } from 'react';
import urlConfig from './../config/url.json';
import FlatButton from 'material-ui/FlatButton';
//import { white, cyan500, cyan300, grey400 } from 'material-ui/styles/colors';
import Snackbar from 'material-ui/Snackbar';
import Dialog from 'material-ui/Dialog';
import { checkDate } from './Common/Utils';
import ReactEcharts from 'echarts-for-react';  
import DirectusSDK from "@directus/sdk-js";
import Datetime from "react-datetime";
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import 'react-datetime/css/react-datetime.css';
import 'react-datepicker/dist/react-datepicker.min.css';
import '../App.css';

//gw var _ = require( 'lodash' );
//gw var jq = require( 'jquery' );
var moment = require( 'moment' );

const Logo = 'icons/poli.png';
const LogoRegFooter = 'icons/rl.png';
const LogoFscFooter = 'icons/fsc.png';

const client = new DirectusSDK({
    url: urlConfig[urlConfig.mode].url,
    project: "_",
    token: "peo" 
});  

/* CONFIGURAZIONE ASCISSE E ORDINATE */
const defaultMesi = [
    {"id_mese": 1, "mese": "Gennaio"},
    {"id_mese": 2, "mese": "Febbraio"},
    {"id_mese": 3, "mese": "Marza"},
    {"id_mese": 4, "mese": "Aprile"},
    {"id_mese": 5, "mese": "Maggio"},
    {"id_mese": 6, "mese": "Giugno"},
    {"id_mese": 7, "mese": "Luglio"},
    {"id_mese": 8, "mese": "Agosto"},
    {"id_mese": 9, "mese": "Settembre"},
    {"id_mese": 10, "mese": "Ottobre"},
    {"id_mese": 11, "mese": "Novembre"},
    {"id_mese": 12, "mese": "Dicembre"}
];

const optionsTipoStatistica = [
    { value: 'diffusione_internet_famiglie', label: 'Diffusione di Internet nelle famiglie'},
    { value: 'famiglie_banda_larga', label: 'Famiglie con accesso a banda larga'},
    { value: 'incidenza_spesa', label: 'Incidenza della spesa totale per R&S sul PIL'},
    { value: 'pil_procapite', label: 'Prodotto Interno Lordo ai prezzi di mercato per abitante'},
    { value: 'ricercatori_su_addetti', label: 'Ricercatori occupati nelle imprese'},
    { value: 'spec_prod_alta_tecnologia', label: 'Specializzazione produttiva nei settori ad alta tecnologia'},
    { value: 'tasso_disoccupazione', label: 'Tasso di Disoccupazione'},
    { value: 'tasso_natalita_imprese', label: 'Tasso di natalità delle imprese'},
    { value: 'utilizzo_internet_imprese', label: 'Utilizzo di Internet nelle imprese'},
];

function getOptionBar(data,anno,regione,title,fonte, yAxisLabel) {
    console.log( 'getOptionBar: '+data+','+anno+','+regione+','+title);
    var myAnno = 'Anno: '+anno;
    var myDataAll = [];	
    var myTitle = "";
    var mySubtitle = "";
    var myDataNordOvest = [];	
    var myDataRegione = [];	
    var myDataxAxis = [];	
    var markLineName = "";
    var markLineyAxis = "";
    var markPoint1 = [];
    var markPoint2 = [];
    var myYLabel = "";
    var myFonte = "";
    var myFonteColor = "#f5e5d5";
    if (fonte!==null){
        myFonte+="Fonte: "+fonte;
        myFonteColor = "#244357";
    }
    for (var key in data) {
        //console.log( 'data[key]: '+JSON.stringify(data[key]) );
        if (data.hasOwnProperty(key)) {
            if (data[key].geo.toLowerCase()==="italy" || data[key].geo.toLowerCase()==="italia") {
                markLineName =  data[key].geo;
                markLineyAxis =  data[key].value;
            }else{
                if (myTitle==="") {
                    myTitle=data[key].title;
                } 
                if (mySubtitle==="") {
                    mySubtitle=data[key].subtitle;
                } 
                if (data[key].geo===regione) {
                    markPoint1.push(parseInt(key-1));
                    markPoint1.push(data[key].value);
                    myDataAll.push('-');
                    myDataNordOvest.push('-');
                    myDataRegione.push(data[key].value);
                }else if (data[key].geo.toLowerCase()==="nord-ovest") {
                    markPoint2.push(parseInt(key-1));
                    markPoint2.push(data[key].value);
                    myDataAll.push('-');
                    myDataNordOvest.push(data[key].value);
                    myDataRegione.push('-');
                }else{
                    myDataAll.push(data[key].value);
                    myDataNordOvest.push('-');
                    myDataRegione.push('-');
                }
                myDataxAxis.push(data[key].geo);
            }
        }
    }                            
    /*
    console.log( 'myDataRegioni: '+JSON.stringify(myDataRegioni) );
    console.log( 'myDataNordOvest: '+JSON.stringify(myDataNordOvest) );
    console.log( 'myDataLiguria: '+JSON.stringify(myDataLiguria) );
    console.log( 'myDataxAxis: '+JSON.stringify(myDataxAxis) );
    */
   var option = {
        baseOption: {
            color: ['#008b00', '#b92222', '#244357'],
            backgroundColor:'#f5e5d5',
            grid: {
                top: 70,
                left: 50,
                right: 100,
                bottom: 0,
                height: 220
            },
            title : [
                {   
                    text: myTitle,
                    subtext: mySubtitle,
                    textStyle: {
                        fontSize: 18,
                        color: '#244357'
                    },
                    subtextStyle: {
                        fontSize: 14,
                        color: '#244357'
                    }
                },
                {
                    text : myFonte,
                    backgroundColor:myFonteColor,
                    textStyle: {
                        fontSize: 12,
                        color: '#fff'
                    },
                    left: '0',
                    top: 'bottom'                    
                }
            ],
            tooltip : {
                trigger: 'axis',
                formatter: function (params) {
                    var tar;
                    if (params[2].value !== '-') {
                        tar = params[2];
                    }else if (params[1].value !== '-') {
                        tar = params[1];
                    }else {
                        tar = params[0];
                    }
    //              return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
                    return tar.name + ' : ' + tar.value + '%';
                }
            },
            legend: {
                data:['Valore']
            },
            toolbox: {
                iconStyle: {
                    normal: {
                        borderColor: '#244357'
                    },
                    emphasis: {
                        borderColor: '#244357'
                    }
                },
                feature : {
    //                dataView : {show: true, readOnly: false},
                    magicType : {show: true, type: ['line', 'bar'], title: {line: 'Linee', bar: 'Barre' }},
                    restore : {show: true, title: 'Ricarica'},
                    saveAsImage : {show: true,title: 'Salva'}
                }
            },
            calculable : true,
            xAxis : [
                {
                    type : 'category',
    //              data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                    data : myDataxAxis,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 45,
                        color: '#244357',
                        fontSize: 10
                    },
                    splitLine: {
                        show: false
                    }
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    name: yAxisLabel,
                    show: true,
                    position: 'left',
                    nameLocation: 'center',
                    nameTextStyle: {
                        padding: 17,
                        fontSize: 10,
                        color: '#244357'
                    },
                    axisLabel: {
                        color: '#244357'
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#244357', 
                            opacity: .2
                        }
                    }
                }
            ],
            series : [
                {
                    name:'Regioni',
                    type:'bar',
                    stack: 'stack',
                    label: {
                        normal: {
                            show: false,
                            position: 'top'
                        }
                    },
                    data: myDataAll,
                    markLine : {
                        symbol: 'none',
                        data : [
                            {
                                name: markLineName,
                                yAxis: markLineyAxis,   
                                label: {
                                    formatter: '{b}: {c}',
                                    color: '#b92222'
                                },                     
                                lineStyle: {
                                    type: 'solid',
                                    color: '#b92222',
                                    width: 2
                                }
                            }
                        ]
                    }                
                },
                {
                    name:'Nord-Ovest',
                    type:'bar',
                    stack: 'stack',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#b92222'
                        }
                    },
                    data: myDataNordOvest
                },
                {
                    name:'Liguria',
                    type:'bar',
                    stack: 'stack',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#244357'
                        }
                    },
                    data: myDataRegione
                }
            ]
        },
        media: [
            {
                option: {
                    grid: {
                        top: 70,
                        left: 50,
                        right: 100,
                        bottom: 0,
                        height: 220
                    },
                    textStyle: {
                        fontSize: 18,
                        color: '#244357'
                    },
                    subtextStyle: {
                        fontSize: 14,
                        color: '#244357'
                    }
                }
            },
            {
                query: {
                    minAspectRatio: 1
                },
                option: {
                    grid: {
                        top: 70,
                        left: 50,
                        right: 100,
                        bottom: 0,
                        height: 220
                    },
                    title : {
                        textStyle: {
                            fontSize: 18,
                            color: '#244357'
                        },
                        subtextStyle: {
                            fontSize: 14,
                            color: '#244357'
                        }
                    }
                }
            },
            {
                query: {
                    maxAspectRatio: 1
                },
                option: {
                    grid: {
                        top: 70,
                        left: 50,
                        right: 100,
                        bottom: 0,
                        height: 220
                    },
                    title : {
                        textStyle: {
                            fontSize: 18,
                            color: '#244357'
                        },
                        subtextStyle: {
                            fontSize: 14,
                            color: '#244357'
                        }
                    }
                }
            },
            {
                query: {
                    maxWidth: 500
                },
                option: {
                    grid: {
                        top: 70,
                        left: 50,
                        right: 60,
                        bottom: 0,
                        height: 200
                    },
                    title : {
                        textStyle: {
                            fontSize: 14,
                            color: '#244357'
                        },
                        subtextStyle: {
                            fontSize: 10,
                            color: '#244357'
                        }
                    }

                }
            }
        ]
    };
    console.log( '##getOptionBar###'+JSON.stringify(option) );
	return option;
};

function getOptionLine(data,regione,title,minY,fonte,yAxisLabel) {
    console.log( 'getOptionLine: '+data+','+regione+','+title+','+minY);
    var myDataAll = [];	
    var myDataxAxis = [];	
    var myRegione = "Regione: "+regione;
    var myTitle = "";
    var mySubtitle = "";
    var myMinY = 0;
    if (minY!==undefined) {
        myMinY = minY;
    }
    var myFonte = "";
    var myFonteColor = "#f5e5d5";
    if (fonte!==null){
        myFonte+="Fonte: "+fonte;
        myFonteColor = "#244357";
    }
    for (var key in data) {
        //console.log( 'data[key]: '+JSON.stringify(data[key]) );
        if (data.hasOwnProperty(key)) {
            if (myTitle==="") {
                myTitle=data[key].title;
            } 
            if (mySubtitle==="") {
                mySubtitle=data[key].subtitle;
            } 
            myDataAll.push(data[key].value);
            myDataxAxis.push(data[key].time);
        }
    }                            
    console.log( 'myDataAll: '+JSON.stringify(myDataAll) );
    console.log( 'myDataxAxis: '+JSON.stringify(myDataxAxis) );
    var option = {
        baseOption: {
            color: ['#008b00', '#b92222', '#244357'],
            backgroundColor:'#f5e5d5',
            grid: {
                top: 70,
                left: 50,
                right: 10,
                bottom: 0,
                height: 300
            },
            title : [
                {   
                    text: myTitle,
                    subtext: mySubtitle,
                    textStyle: {
                        fontSize: 18,
                        color: '#244357'
                    },
                    subtextStyle: {
                        fontSize: 14,
                        color: '#244357'
                    }
                },
                {
                    text : myFonte,
                    backgroundColor:myFonteColor,
                    textStyle: {
                        fontSize: 12,
                        color: '#fff'
                    },
                    left: '0',
                    top: 'bottom'                    
                }
            ],            
            tooltip : {
                trigger: 'axis',
                formatter: 'Anno: {b}<br />Percentuale: {c}%'
            },
            legend: {
                data:['Valore']
            },
            toolbox: {
                iconStyle: {
                    normal: {
                        borderColor: '#244357'
                    },
                    emphasis: {
                        borderColor: '#0f2645'
                    }
                },
                feature : {
    //                dataView : {show: true, readOnly: false},
                    magicType : {show: true, type: ['line', 'bar'], title: {line: 'Linee', bar: 'Barre' }},
                    restore : {show: true, title: 'Ricarica'},
                    saveAsImage : {show: true,title: 'Salva'}
                }
            },
            calculable : true,
            xAxis : [
                {
                    type : 'category',
    //              data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                    data : myDataxAxis,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        interval: 0,
                        color: '#0f2645'
                    },
                    splitLine: {
                        show: false
                    }
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    min: myMinY,

                    name: yAxisLabel,
                    show: true,
                    position: 'left',
                    nameLocation: 'center',
                    nameTextStyle: {
                        padding: 37,
                        fontSize: 10,
                        color: '#244357'
                    },
                    axisLabel: {
                        color: '#244357'
                    },

                    splitLine: {
                        lineStyle: {
                            color: '#0f2645', 
                            opacity: .2
                        }
                    }
                }
            ],
            series : [
                {
                    name:'Regioni',
                    type:'line',
                    stack: 'stack',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#244357'
                        }
                    },
                    data: myDataAll,
                }
            ]
        },
        media: [
            {
                option: {
                    grid: {
                        top: 70,
                        left: 70,
                        right: 10,
                        bottom: 0,
                        height: 300
                    },
                    title : {
                        textStyle: {
                            fontSize: 18,
                        },
                        subtextStyle: {
                            fontSize: 14,
                        }
                    }
                }
            },
            {
                query: {
                    minAspectRatio: 1
                },
                option: {
                    grid: {
                        top: 70,
                        left: 70,
                        right: 10,
                        bottom: 0,
                        height: 300
                    },
                    title : {
                        textStyle: {
                            fontSize: 18,
                        },
                        subtextStyle: {
                            fontSize: 14,
                        }
                    }
                }
            },
            {
                query: {
                    maxAspectRatio: 1
                },
                option: {
                    grid: {
                        top: 70,
                        left: 70,
                        right: 10,
                        bottom: 0,
                        height: 300
                    },
                    title : {
                        textStyle: {
                            fontSize: 18,
                        },
                        subtextStyle: {
                            fontSize: 14,
                        }
                    }
                }
            },
            {
                query: {
                    maxWidth: 500
                },
                option: {
                    grid: {
                        top: 70,
                        left: 70,
                        right: 10,
                        bottom: 0,
                        height: 300
                    },
                    title : {
                        textStyle: {
                            fontSize: 14,
                        },
                        subtextStyle: {
                            fontSize: 10,
                        }
                    }
                }
            }
        ]
    };
    console.log( '##getOptionLine###'+JSON.stringify(option) );
	return option;
};

class Home extends Component {

    constructor( props ) {
        super( props );
        this.state = {

            dataLoaded: false,
            dataRegioniLoaded: false,
            
            jsonDataStatistica: undefined,
            jsonDataStatisticaRegione: undefined,
                 
            optionRegioni: undefined,
            jsonFind: false,
            open: false,
            message: "",
            openDialog: false,

            annoStatistica: moment().format( 'YYYY' ),

            fonteStatistica: null,
            regioneStatistica: 'Liguria',
            tipoStatistica: "diffusione_internet_famiglie",
            labeltipoStatistica: "Diffusione di Internet nelle famiglie",
            yAxisLabel: null
        }
        this.renderModello = this.renderModello.bind( this );
        
        this.exit = this.exit.bind( this );
        this.getStatistica = this.getStatistica.bind( this );
        this.getStatisticaRegione = this.getStatisticaRegione.bind( this );
        this.caricaRegioniOption = this.caricaRegioniOption.bind( this );

        this.handleDialogClose = this.handleDialogClose.bind( this );
        this.findObjectByKey = this.findObjectByKey.bind( this );

        this.handleCambioData = this.handleCambioData.bind(this);
        this.handleInputChange = this.handleInputChange.bind( this );
    }

    handleDialogClose = () => {
        this.setState( { openDialog: false } );
    };

    async getStatistica(anno, tipo) {
        console.log("getStatistica - anno: "+anno+" Tipo:"+tipo);
        this.setState({dataLoaded: false});
        var newDataStatistica = []; 
        var paramSDK = {
            filter: {
                time: {eq: anno}
            }
        };
        /*
        if (tipo==='tasso_disoccupazione') {
            paramSDK = {
                filter: {
                    time: {eq: anno},
                    eta1: {logical: 'and', eq: 'Y_GE15'},
                    sesso: {logical: 'and', eq: 'totale'},
                    titolo_studio: {logical: 'and', eq: 99},
                    durata_della_disoccupazione: {logical: 'and', eq: 'totale'},
                }
            };
        };
        */
        try {
            if (urlConfig[urlConfig.mode].ambiente==="office") {
                newDataStatistica = await client.getItems(tipo, paramSDK);
            } else {
                newDataStatistica = await client.getItems(tipo, paramSDK);
            }
            console.log( 'getStatistica: '+ JSON.stringify(newDataStatistica));
            if (typeof newDataStatistica.data[0] === 'undefined') {
                this.setState({dataLoaded: true, jsonDataStatistica: newDataStatistica, fonteStatistica: null }); 
                console.log( 'fonteStatistica: null');
            }else{
                this.setState({dataLoaded: true, jsonDataStatistica: newDataStatistica, fonteStatistica: newDataStatistica.data[0].fonte }); 
                console.log( 'fonteStatistica: '+ newDataStatistica.data[0].fonte);
            }            
        } catch (error) {
          console.log(error);
        }
        //console.log("getJSON: " + urlConfig[urlConfig.mode].ambiente);
    }

    async getStatisticaRegione(tipo, regione) {
        console.log("getStatisticaRegione - Regione:"+regione+" Tipo:"+tipo);
        this.setState({dataRegioniLoaded: false});
        var newDataStatistica = []; 
        var paramSDK = {
            filter: {
                geo: {eq: regione}
            }
        };
        /*
        if (tipo==='tasso_disoccupazione') {
            paramSDK = {
                filter: {
                    geo: {eq: regione},
                    eta1: {logical: 'and', eq: 'Y15-74'},
                    sesso: {logical: 'and', eq: 'totale'},
                    titolo_studio: {logical: 'and', eq: 99},
                    durata_della_disoccupazione: {logical: 'and', eq: 'totale'},
                }
            };
        };
        */
        try {
            if (urlConfig[urlConfig.mode].ambiente==="office") {
                newDataStatistica = await client.getItems(tipo, paramSDK);
            } else {
                newDataStatistica = await client.getItems(tipo, paramSDK);
            }
            console.log( 'getStatisticaRegione: '+ JSON.stringify(newDataStatistica));
            if (typeof newDataStatistica.data[0] === 'undefined') {
                this.setState({dataRegioniLoaded: true, jsonDataStatisticaRegione: newDataStatistica, fonteStatistica: null, yAxisLabel: null }); 
                console.log( 'fonteStatistica: null');
            }else{
                this.setState({dataRegioniLoaded: true, jsonDataStatisticaRegione: newDataStatistica, fonteStatistica: newDataStatistica.data[0].fonte, yAxisLabel: newDataStatistica.data[0].yLabel }); 
                console.log( 'fonteStatistica: '+ newDataStatistica.data[0].fonte);
            }            
        } catch (error) {
          console.log(error);
        }
        //console.log("getJSON: " + urlConfig[urlConfig.mode].ambiente);
    }

    async getRegioni(tipo) {
        console.log("getRegioni - Tipo:"+tipo);
        this.setState({dataRegioniLoaded: false});
        var newDataRegioni = []; 
        var newOptionRegioni = []; 
        var paramSDK = {
            fields: 'geo',
            groups: 'geo'
        };
        try {
          if (urlConfig[urlConfig.mode].ambiente==="office") {
            newDataRegioni = await client.getItems(tipo, paramSDK);
          } else {
            newDataRegioni = await client.getItems(tipo, paramSDK);
          }
          console.log( 'getRegioni: '+ JSON.stringify(newDataRegioni));
          newOptionRegioni = this.caricaRegioniOption(newDataRegioni);
          console.log( 'newOptionRegioni: '+ JSON.stringify(newOptionRegioni));
          this.setState({dataRegioniLoaded: true, optionRegioni: newOptionRegioni }); 
        } catch (error) {
          console.log(error);
        }
        //console.log("getJSON: " + urlConfig[urlConfig.mode].ambiente);
    }

    handleRequestClose = () => {
        this.setState( {
            open: false,
        } );
    };

    /**
     * Funzione invocata quando si clicca sul pulsante esci
     */
    exit() {
        const url = urlConfig[urlConfig.mode].exit;
        window.open( url, '_self' )
    }

    findObjectByKey = (array, key, value) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return i;
            }
        }
        return null;
    }

    /*
    handleInputChangeTipoStatistica = ( event ) => {
        console.log( 'handleInputChangeTipoStatistica *** event: '+JSON.stringify(event.target.value) );
        this.setState( {
            jsonDataStatistica: undefined,
            tipoStatistica: event.target.value
        } )
        this.getStatistica(this.state.periodoStatistica, event.target.value);

    }
    */
    //gestisce il cambio di data: se ci sono modifiche non salvate chiede conferma
    handleCambioData = ( date) => {
        console.log( 'handleCambioData  data:'+date );
        this.setState({
            jsonDataStatistica: undefined, jsonDataStatisticaRegione: undefined
            },() => { 
            console.log('new state', this.state); 
            if ( moment( date ).isValid() && date !== undefined ) {
                var annoStatistica = moment( date ).format( 'YYYY' );
                this.setState({
                    annoStatistica: annoStatistica,
                });
                console.log("ho fatto setState con " + annoStatistica);
                //Caricare nuovo json
                try {
                    this.getStatistica(annoStatistica,this.state.tipoStatistica);
                } catch (error) {
                    console.log(error);
                }
                try {
                    this.getStatisticaRegione(this.state.tipoStatistica,this.state.regioneStatistica);
                } catch (error) {
                    console.log(error);
                }
            }
        })
    }

    //Gestisce l'update del JSON quando avviene un cambiamento
    handleInputChange = ( e, date ) => {
        console.log( 'handleInputChange data:'+date+' '+e.value );
        if (date==="regione") {
            this.setState({
                    jsonDataStatistica: undefined, regioneStatistica: e.value
                },() => { 
                console.log('new state', this.state); 
                try {
                    this.getStatistica(this.state.annoStatistica,this.state.tipoStatistica);
                } catch (error) {
                    console.log(error);
                }
                try {
                    this.getStatisticaRegione(this.state.tipoStatistica,this.state.regioneStatistica);
                } catch (error) {
                    console.log(error);
                }
            })
        }else if (date==="tipo") {
            this.setState({
                jsonDataStatistica: undefined, tipoStatistica: e.value, labeltipoStatistica: e.label
                },() => { 
                console.log('new state', this.state); 
                try {
                    this.getStatistica(this.state.annoStatistica,this.state.tipoStatistica);
                } catch (error) {
                    console.log(error);
                }
                try {
                    this.getStatisticaRegione(this.state.tipoStatistica,this.state.regioneStatistica);
                } catch (error) {
                    console.log(error);
                }
            })
        }

        console.log( 'handleInputChange: '+JSON.stringify(e.value) );
        //this.setState( { jsonDataStatistica: jsonDataStatistica, tipoStatistica: tipoStatistica} );
    }

    componentWillMount() {
        //console.log( 'componentWillMount data:'+this.state.annoStatistica );
        this.setState({dataLoaded: false, dataRegioniLoaded: false});
        try {
            this.getRegioni(this.state.tipoStatistica);
        } catch (error) {
            console.log(error);
        }
        try {
            this.getStatistica(this.state.annoStatistica,this.state.tipoStatistica);
        } catch (error) {
            console.log(error);
        }
        try {
            this.getStatisticaRegione(this.state.tipoStatistica,this.state.regioneStatistica);
        } catch (error) {
            console.log(error);
        }
      }

    caricaStatisticaOption(dati) {
        const datiStatistica = JSON.parse(JSON.stringify(dati));
        const newStatOption = [];
        for (var key in datiStatistica) {
            if (datiStatistica.hasOwnProperty(key)) {
                newStatOption.push(datiStatistica);
            }
        }
        //console.log('DOPO -> '+JSON.stringify(newMapOption));
        return newStatOption;
    } 

    caricaRegioniOption(dati){
        const datiRegioni = JSON.parse(JSON.stringify(dati.data));
        const newRegioniOption = [];
        for (var key in datiRegioni) {
            if (datiRegioni.hasOwnProperty(key)) {
                var option = { value: datiRegioni[key].geo, label: datiRegioni[key].geo };
                newRegioniOption.push(option);
            }
        }
        //console.log('DOPO -> '+JSON.stringify(newMapOption));
        return newRegioniOption;
    }
    renderModello(tipo) {
        console.log("#### renderModello ####"+JSON.stringify(this.state.jsonDataStatistica));
        console.log("#### renderModello ####"+JSON.stringify(this.state.jsonDataStatisticaRegione));
        if ( this.state.jsonDataStatistica === undefined ) {
            return <div>Attendere, prego...</div>
        }
        else {
            let rowModello = [];
            let minY = 0;
            if ( this.state.tipoStatistica === 'pil_procapite' ) {
                minY=25000;
            }
            for (var key in this.state.jsonDataStatisticaRegione) {
                if (this.state.jsonDataStatisticaRegione.hasOwnProperty(key)) {
                    console.log( '##### jsonDataStatisticaRegione[key]: '+JSON.stringify(this.state.jsonDataStatisticaRegione[key].length) );
                    if (this.state.jsonDataStatisticaRegione[key].length > 0) {
                        var newOptionRegione = getOptionLine(this.state.jsonDataStatisticaRegione[key],this.state.regioneStatistica,this.state.labeltipoStatistica,minY, this.state.fonteStatistica, this.state.yAxisLabel);
                        rowModello.push(
                            <div class="_box_famiglie_banda_larga col m12">
                                <h2>Andamento del periodo per il Comparto territoriale/regione: { this.state.regioneStatistica}</h2>
                                <ReactEcharts  
                                ref={(e) => { this.echarts_react = e; }}
                                key={'streg_'+key} 
                                option={newOptionRegione} 
                                notMerge={true}
                                lazyUpdate={true}
                                className='react_for_echarts _famiglie_banda_larga'
                                style={{height: '420px'}}
                                />
                            </div>
                        )
                    }else{
                        rowModello.push(
                            <div class="_box_famiglie_banda_larga col m12">
                                <h2>Andamento del periodo per il Comparto territoriale/regione: { this.state.regioneStatistica}</h2>
                                <p>Dati non disponibili...</p>
                            </div>
                        )
                    }
                }
            }
            for (var key1 in this.state.jsonDataStatistica) {
                if (this.state.jsonDataStatistica.hasOwnProperty(key1)) {
                    console.log( '###### jsonDataStatistica[key1]: '+JSON.stringify(this.state.jsonDataStatistica[key1].length) );
                    if (this.state.jsonDataStatistica[key1].length > 0) {
                        var newOptionFamiglieBandaLarga = getOptionBar(this.state.jsonDataStatistica[key1],this.state.annoStatistica,this.state.regioneStatistica,this.state.labeltipoStatistica, this.state.fonteStatistica, this.state.yAxisLabel);
                        rowModello.push(
                            <div class="_box_famiglie_banda_larga col m12">
                                <h2>Posizionamento delle regioni italiane per l’anno { this.state.annoStatistica}</h2>
                                <ReactEcharts  
                                ref={(e) => { this.echarts_react = e; }}
                                key={'st_'+key1} 
                                option={newOptionFamiglieBandaLarga} 
                                notMerge={true}
                                lazyUpdate={true}
                                className='react_for_echarts _famiglie_banda_larga'
                                style={{height: '420px'}}
                                />
                            </div>
                        )
                    }else{
                        rowModello.push(
                            <div class="_box_famiglie_banda_larga col m12">
                                <h2>Posizionamento delle regioni italiane per l’anno { this.state.annoStatistica}</h2>
                                <p>Dati non disponibili...</p>
                            </div>
                        )
                    }
                }
            }
            return rowModello;
        }
    }

    getLoadingOption = () => {
        return {
        text: 'caricamento...',
        color: '#4413c2',
        textColor: '#270240',
        maskColor: 'rgba(194, 88, 86, 0.3)',
        zlevel: 0
        };
    };

    render() {
        //Azioni relative al Dialog
        const actions = [
            <FlatButton
                label="Annulla"
                primary={true}
                onClick={this.handleDialogClose}
            />,
            <FlatButton
                label="Esci senza salvare"
                primary={true}
                onClick={this.exit}
            />,
        ];
        if ( this.state.jsonDataStatistica !== undefined ) {
            return (
                <div className="App-home">
                    <div className="row">
                        <div class="header">
                            <img class="logo" src={Logo} alt="Logo Poli Liguri" width="76" height="100" />
                            <h2 class="no_toc">Indicatori statistici per la ricerca e l’innovazione</h2>
                        </div>
                        <div id="fixed-left" className="col sele">
                            <label class="datePicker">Selezione Anno</label>
                            <Datetime 
                                className="datePicker"
                                dateFormat="YYYY" 
                                timeFormat={false} 
                                inputProps={{ placeholder: 'N/A' }}
                                closeOnSelect={true} 
                                defaultValue={checkDate( this.state.annoStatistica )}
                                onChange={( e ) => this.handleCambioData( e )}
                            />
                            <label>Selezione Indicatore</label>
                            <Select
                                name='tipoStatistica'
                                value={this.state.tipoStatistica}
                                options={optionsTipoStatistica}
                                onChange={( e ) => this.handleInputChange( e, 'tipo' )}
                                placeholder={"Selezionare tipologia..."}
                            />
                            <label>Selezione Comparto territoriale/regione</label>
                            <Select
                                name='regioneStatistica'
                                value={this.state.regioneStatistica}
                                options={this.state.optionRegioni}
                                onChange={( e ) => this.handleInputChange( e, 'regione' )}
                                placeholder={"Selezionare la Regione..."}
                            />
                        </div>
                        <div id="mainwithsidebar" className="col m9">
                            {this.renderModello()}
                        </div>    
                        <footer>
                            <div class="footer_container">
                                <div class="block">
                                    <img id="logoRegFooter" src={LogoRegFooter} alt="Logo Regione Liguria" />
                                </div>
                                <div class="block">
                                    <p>
                                        <span class="title">Sede Amministrativa</span>
                                        <span class="title2">Indirizzo</span>
                                        <span>Piazza De Ferrari, 1</span>
                                        <span>16121 Genova</span>
                                    </p>                                    
                                </div>
                                <div class="block">
                                    <p>
                                        <span class="title">Recapiti telefonici</span>
                                        <span class="title2">Tel. centralino</span>
                                        <span>+39 010 54851</span>
                                        <span class="title2">Fax</span>
                                        <span>+39 010 5488742</span>
                                        <span class="title2">Numero verde</span>
                                        <span>800 445 445</span>
                                    </p>                                    
                                </div>
                                <div class="block">
                                    <img id="logoFonFooter" src={LogoFscFooter} alt="Fondo per lo Sviluppo e la Coesione" />
                                </div>
                		    </div>
		                </footer>




                    </div>
                    <Snackbar
                        className='myMessage'
                        open={this.state.open}
                        message={this.state.message}
                        autoHideDuration={4000}
                        onRequestClose={this.handleRequestClose}
                        action="chiudi"
                        onActionTouchTap={this.handleRequestClose}

                    />
                    <Dialog
                        title="Conferma uscita"
                        actions={actions}
                        modal={false}
                        open={this.state.openDialog}
                        onRequestClose={this.handleDialogClose}
                    >
                        Sono presenti modifiche non salvate, uscire comunque?
                    </Dialog>
                </div>
            );
        }
        else {
            return <div><center><h2>Attendere, prego...</h2></center></div>
        }
    }
}
export default Home;



// WEBPACK FOOTER //
// ./src/Components/Home.jsx